const convertToFlatTree = (items, rootId) => {
  const flatTree = [];

  const processItems = (itemsList, parentId) => {
    itemsList.forEach((item) => {
      const node = {
        id: item.id,
        parent: parentId,
        text: item.title,
        droppable: item.droppable,
        data: item,
      };

      flatTree.push(node);

      if (item.items && item.items.length > 0) {
        processItems(item.items, item.id);
      }
    });
  };

  processItems(items, rootId);

  return flatTree;
};

const convertFromFlatTree = (flatTree, rootId) => {
  const childrenByParent = new Map();

  flatTree.forEach((node) => {
    const parentId = node.parent;
    const existing = childrenByParent.get(parentId);

    if (existing) {
      existing.push(node);
    } else {
      childrenByParent.set(parentId, [node]);
    }
  });

  const buildHierarchy = (parentId, parentOrder) => {
    const children = childrenByParent.get(parentId) || [];

    return children.reduce((acc, node, index) => {
      if (!node.data) return acc;

      const order = parentOrder ? `${parentOrder}.${index + 1}` : `${index + 1}`;
      const { id } = node;

      acc.push({
        ...node.data,
        id,
        title: node.text,
        order,
        items: buildHierarchy(id, order),
      });

      return acc;
    }, []);
  };

  return buildHierarchy(rootId);
};

export { convertToFlatTree, convertFromFlatTree };
